import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      dateNow: this.dateMonth(new Date()),
      data_outstand: '',
      data_list: [],
      zone_list: [],
      zone: '',
      data_month: '',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      sum_amount: 0,
      sum_paid: 0
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getOutstand () {
      this.$store.state.isLoading = true
      api.getOverDue(
        {
          status: '0',
          date: moment(this.dateNow).format('YYYY-MM-DD'),
          zone: this.zone,
          active_page: 1,
          per_page: 10000000
        },
        this.header,
        (result) => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_outstand = JSON.stringify(result.data.pagination)
            this.data_list = result.data.pagination
            this.sum_amount = 0
            this.sum_paid = 0
            this.data_list.forEach(val => {
              // this.sum_amount += val['invoice_amount'] - val['invoice_payment']
              this.sum_amount += parseFloat(val['total_amount'])
              this.sum_paid += parseFloat(val['payment_amount'])
            })
            this.data_month = this.monthYearFormat(this.dateNow)
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getZoneAll()
    this.getOutstand()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/outstanding_report.js